import { render } from "./PodcastPage.vue?vue&type=template&id=2a53bbc9&scoped=true"
import script from "./PodcastPage.vue?vue&type=script&lang=js"
export * from "./PodcastPage.vue?vue&type=script&lang=js"

import "./PodcastPage.vue?vue&type=style&index=0&id=2a53bbc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a53bbc9"]])

export default __exports__